export const BROADCAST_CHANNEL_NAME = "token_update_channel";
export const IS_REFRESHING = "is_refreshing";
export const TOKEN_USED = "token_used";
export const IS_TOKEN_FINISH = "is_finish";
